import Service from './serviceFactory';

const ServiceAPI = new Service(
  import.meta.env.VITE_API_BASEURL ?? 'http://localhost:3000',
);

export { ServiceAPI as default };
